import React from "react";
import {
    BoxIsolatedContent,
    ContentMd2Top,
    FlexColumn,
    FlexColumnCentered,
    RecoveryCross
} from "../../../components/ui/Content";
import {Body1, Body1PointerLink, FormTitle} from "../../../components/Font";
import {useNavigate} from "react-router-dom";
import {Cross} from "../../../icon/Icon";

export const RecoveryCodeOutdated = () => {
    const navigate = useNavigate();
    const goBack = () => {
        navigate('/sign-in', {replace: true})
    }
    return <FlexColumnCentered className={'box-isolated'}>
        <BoxIsolatedContent>
        <FlexColumn style={{width: '100%'}}>
            <FlexColumnCentered>
                <FormTitle>Ссылка устарела</FormTitle>
            </FlexColumnCentered>
            <RecoveryCross onClick={() => goBack()}>
                <Cross/>
            </RecoveryCross>
            <ContentMd2Top>
                <Body1 style={{marginBottom: '24px'}}>Пройдите процесс восстановления пароля снова</Body1>
                <Body1PointerLink onClick={() => goBack()}>Вернуться к началу процесса восстановления</Body1PointerLink>
            </ContentMd2Top>
        </FlexColumn>
        </BoxIsolatedContent>
    </FlexColumnCentered>
}
